import "../styles/css/request-estimate.css"
import {useState} from "react";
const EstimateRequestThanksPage: React.FC = () => {
    const [activeProperty, setActiveProperty] = useState<string>('Residential')
    return (
        <div className='request-body'>
            <div className="container estimate-container">
                <div className="page-card estimate-thanks">
                    <i className="fas fa-thumbs-up thanks-icon"></i>
                    <h1>Thanks!</h1>
                    <p>Your request for an estimate has been sent. Please call or email us if you have any questions or concerns.</p>
                    <p>(847) 970-5900<br /><a href="mailto:barrecablacktop@gmail.com">barrecablacktop@gmail.com</a></p>
                </div>
            </div>
        </div>
    )
}
export default EstimateRequestThanksPage;